import 'clover/utils/functions'
import 'clover/utils/FrameLoader'
import SmartLoader from 'clover/utils/SmartLoader'

class ResourceManager {
    constructor() {
        // 打包文件处理
        this.packMap = {}
        this.fileHanlderMap = {}
        this.md5Map = new Md5Map();
        this.persistMap = {}
        this.zipMap = new ZipMap();
        this.pvrlists = {}
        this.pvrtestlists = [ 
        //    'cocos/champion_game_Icon.plist',    
        //     'cocos/champion_start.plist',        
        //     'cocos/champion_explain.plist',      
        //     'cocos/champion_game_main.plist',    
        //     'cocos/champion_main.plist',
        //     'cocos/champion_reward.plist',       
        //     'cocos/champion_game_victory.plist' ,

        //     'cocos/pass_game_Icon.plist',
        //     'cocos/pass_game_key.plist',
        //     'cocos/battlepass_gift.plist',
        //     'cocos/battlepass_gift1.plist',
        //     'cocos/battlepass_shows.plist',
        //     'cocos/battlePass_interface.plist',
        //     'cocos/pass_game_main.plist',
        //     'cocos/battlePass_interface1.plist',
        //     'cocos/pass_game_main1.plist',
        //     'cocos/battlepass_banner.plist',
        //     'cocos/champion_reward.plist',
        //     'cocos/common_bubble.plist',
        //     'cocos/battlepass_explain.plist',
        //     'cocos/battlepass_reward.plist',
        //     'spine/gxhd.atlas',

        //     'cocos/fishing_start.plist',
        //     'spine/fashing_star.atlas',
        //     'cocos/fishing_illustrations.plist',
        //     'cocos/fishing.plist',
        //     'cocos/fishing_icon.plist',
        //     'spine/fishing_result.atlas',
        //     'spine/fishing_bg.atlas',
        //     'spine/fishing_fisher.atlas',
        //     'spine/fishing_sea.atlas',
        //     'spine/jbly_tzcg.atlas',
        //     'cocos/fishing_rank.plist',
        //     'cocos/fishing_explain.plist',
        //     'cocos/fishing_explain02.plist'
            

        ].reduce((accumulator, currentValue) => {
            accumulator[currentValue] = 1;
            return accumulator;
          }, {});
    }

    get(name) {
        return cc.loader.getRes(name)
    }

    getFlatMd5Map() {
        return this.md5Map.getFlat();
    }

    registerPackMap(packMap) {
        this.packMap = {}
        for (let key in packMap) {
            let realKey = getRealResourceName(key)
            this.packMap['packed/' + realKey] = packMap[key]
        }
    }

    registerPVRList(map){
        let forceBanPVR = cc.UserDefault.getInstance().getBoolForKey("ForceBanPVR", false)
        if (forceBanPVR == false){
            try {
                this.pvrlists = {}
                for (let value of map["Pvrlists"]) {
                    this.pvrlists[value] = 1
                }
                console.log("pvr pvrlists", this.pvrlists)
            } catch (error) {
                
            }
        }else{
            window.logCenter && logCenter.error(new Error(`ForceBanPVR`), 'PvrDataError')
        }
    }

    /**
     * 注册资源总表
     * @param {*} md5Map 
     */
    registerMd5Map(md5Map) {
        this.md5Map.addMap(md5Map)
    }

    /**
     * 添加一条资源映射信息
     * @param {*} shortPath 
     * @param {*} md5Path 
     */
    addMd5Mapping(shortPath, md5Path) {
        this.md5Map.add(shortPath, md5Path)
    }

    /**
     * 获取文件的Md5路径
     * @param {*} shortPath 
     */
    getFileMd5(shortPath) {
        //支持etc的平台优先尝试下载etc文件
        if (checkSupportETC(window.canvas)){
            let ktxPath = shortPath + ".ktx"
            let {md5, zip} = this.md5Map.get(ktxPath)
            if (md5){
                let ext = cc.path.extname(ktxPath) || ''
                if (zip) {
                    this.addZipMapping(md5, ext, zip);
                }

                return md5 + ext
            }
        }
        let {md5, zip} = this.md5Map.get(shortPath);
        if (md5) {
            let ext = cc.path.extname(shortPath) || ''
            if (zip) {
                this.addZipMapping(md5, ext, zip);
            }

            return md5 + ext
        }
        return null
    }

    /**
     * 增加一条Zip映射信息
     * @param {*} md5 
     * @param {*} ext 
     * @param {*} zipMd5 
     */
    addZipMapping(md5, ext, zipMd5) {
        this.zipMap.add(md5, ext, zipMd5);
    }

    /**
     * 获取映射的zip路径
     * @param {*} md5Path 
     */
    getZip(md5Path) {
        return this.zipMap.get(md5Path);
    }
    
    getLevelMd5(levelId) {
        let {md5, zip} = this.md5Map.get(`meta/level/${levelId}.json`);
        return md5? md5.replace('/', ''): null;
    }

    _completeListItem(path, resourceObj, isHandleSmallRes, isUnpack) {
        let packConfig = this.getPackConfig(path)
        if (packConfig) {
            packConfig.forEach(packedItem => {
                if (isUnpack) {
                    let key = isHandleSmallRes ? getRealResourceName(packedItem) : packedItem
                    resourceObj[key] = true
                }
                this._completeListItem(packedItem, resourceObj, isHandleSmallRes, isUnpack)
            })
        } else {
            this._addSameNamePng(resourceObj, path, isHandleSmallRes)
        }
    }

    getPackConfig(path) {
        return this.packMap && this.packMap[getRealResourceName(path)]
    }

    registerTypeHandler(type, handler) {
        this.fileHanlderMap[type] = handler
    }

    getSameNamePng(file) {
        // plist/fnt自动加载同名png
        let type = cc.path.extname(file)
        if (type === '.plist') {
            if (window.mini && window.mini.supportPVR() && this.pvrlists[file] ||  __DEBUG && this.pvrtestlists[file]){
                // console.log("pvr replace", file.replace(/\.plist$/, '.pvr'))
                return file.replace(/\.plist$/, '.pvr')
            }
            return file.replace(/\.plist$/, '.png')
        } else if (type === '.fnt') {
            if (window.mini && window.mini.supportPVR() && this.pvrlists[file] ||  __DEBUG && this.pvrtestlists[file]){
                console.log("pvr replace", file.replace(/\.fnt$/, '.pvr'))
                return file.replace(/\.fnt$/, '.pvr')
            }
            return file.replace(/\.fnt$/, '.png')
        } else if (type === '.atlas') {
            if (window.mini && window.mini.supportPVR() && this.pvrlists[file] ||  __DEBUG && this.pvrtestlists[file]){
                console.log("pvr replace", file.replace(/\.plist$/, '.pvr'))
                return file.replace(/\.atlas$/, '.pvr')
            }
            return file.replace(/\.atlas$/, '.png')
        } else if (type === '.skel') { //二进制保留
            return file
        }

        return null
    }

    _addSameNamePng(obj, item, isHandleSmallRes) {
        let png = this.getSameNamePng(item)
        if (png) {
            png = isHandleSmallRes ? getRealResourceName(png) : png
            obj[png] = true
        }
    }

    /**
     * 补全list，包括从pack中取出
     *
     * @param {Array} list
     * @param {Boolean} isHandleSmallRes    是否处理6x，loader中存储的名字并没有6x，卸载时不使用6x名
     * @param {Boolean} isUnpack            是否添加pack中的文件，在加载时不需要实际加载pack中的文件，只需要加入同名图片
     * @returns
     * @memberof ResourceManager
     */
    completeList(list, isHandleSmallRes, isUnpack) {
        if (!(list instanceof Array)) {
            list = [list]
        }
        let resources = {}
        let funcList = []
        // this._completeList(list, resources, funcList, isHandleSmallRes, isUnpack, true)
        list = $tableToArray(list);
        list.forEach((item)=> {
            if (typeof item === 'string') {
                this._completeListItem(item, resources, isHandleSmallRes, isUnpack)
                let key = isHandleSmallRes ? getRealResourceName(item) : item
                resources[key] = true
            } else if (typeof item === 'function') {
                funcList.push(item)
            } else {
                cc.warn('ResourceManager:', 'unknown resource type in resource list')
            }
        });
        return funcList.concat(Object.keys(resources))
    }

    handleFile(item) {
        let ext = cc.path.extname(item)
        let fileHandler = this.fileHanlderMap[ext]
        if (fileHandler) {
            fileHandler.call(this, item)
        }
    }

    createLoader(list, originOptions = {}) {
        let realList = this.completeList(list, true, false)
        let options = Object.assign({}, originOptions, {
            onSuccess: () => {
                realList.forEach(item => this.handleFile(item))
                originOptions.onSuccess && originOptions.onSuccess()
            }
        })
        return new SmartLoader(realList, options)
    }

    load(list, options) {
        let loader = this.createLoader(list, options)
        return loader.load()
    }

    // TODO: 流程统一化
    ensureLoad(list, cb) {
        let loader = this.createLoader(list, {
            onSuccess: cb,
            onFailure() {
                alert('加载失败，请点击确定重试')
                loader.retry()
            }
        })
        return loader.load()
    }

    loadWithTip(list, onSuccess, onFailure, onCancel, isShowTip = true) {
        let called = false
        let loadId

        if (isShowTip) {
            loadId = LoadingPanelLogic.getInstance().add(null, createCallback(onCancel))
        }

        function createCallback(cb) {
            return function () {
                if (!called) {
                    called = true
                    isShowTip && LoadingPanelLogic.getInstance().remove(loadId)
                    cb && cb()
                }
            }
        }

        return timeoutPromise(this.load(list), cc.loader.timeout)
            .then(createCallback(onSuccess))
            .catch(error => {
                createCallback(onFailure)()
                let listStr = "list is null";
                if(list) {
                    if(list instanceof Array) {
                        listStr = list.join(',');
                    } else if(typeof list == "string"){
                        listStr = list;
                    }
                }
                console.error(error, listStr);
                window.logCenter && logCenter.error(new Error(JSON.stringify(error) + listStr), "ResMgrError");
            })
    }

    loadScript(ensureFunc) {
        return timeoutPromise(ensureFunc, cc.loader.timeout)
    }

    /**
     * 持久化资源，被持久化的资源不会被卸载
     * @param {string | string[]} list 
     */
    persist(list) {
        list = this.completeList(list, false, true);
        list.forEach(v=>this.persistMap[v] = true);
    }

    omitPersisted(list) {
        return list.filter(file => !this.persistMap[file])
    }

    release(list, isReleaseInLoader = true) {
        let realList = this.completeList(list, false, true)
        // 其他pack中可能包含，再滤一遍
        realList = this.omitPersisted(realList)
        let plist = []
        realList.forEach(item => {
            let ext = cc.path.extname(item)
            if (ext === '.png' || ext === '.pvr' || ext === '.jpg' || ext === '.jpeg') {
                // 采用refnum管理是否移除，如果refnum不为空，则不会从loader中移除
                cc.textureCache.removeTextureForKey(item)
                // removeTextureForKey中refnum为0的会被清除
                // // 微信中图片有本地缓存，从loader中清除以降低内存及显存使用
                // if (isReleaseInLoader) {
                //     cc.loader.release(item)
                // }
            } else {
                if (ext === '.plist') {
                    plist.push(item);
                }
                if (isReleaseInLoader) {
                    cc.loader.release(item)
                }
            }
        })
        for(let i = 0; i < plist.length; i++) {
            if(!cc.loader.getRes(getRealResourceName(plist[i]).replace(".plist", ".png")) && !cc.loader.getRes(getRealResourceName(plist[i]).replace(".plist", ".pvr"))) {
                FrameLoader._unloadImageWithPlist(plist[i], true);
            }
        }
        if (cc.sys.platform === cc.sys.WECHAT_GAME) {
            mini.triggerGC()
        }
    }
    forceRelease(list) {
        let realList = this.completeList(list, false, true)
        // 其他pack中可能包含，再滤一遍
        // realList = this.omitPersisted(realList)
        let plist = []
        realList.forEach(item => {
            let ext = cc.path.extname(item)
            if (ext === '.png' || ext === '.pvr' || ext === '.jpg' || ext === '.jpeg') {
                cc.textureCache.forceRemoveTextureForKey(item)
                console.log("forceRelease cc.textureCache.removeTextureForKey", item)
            } else {
                if (ext === '.plist') {
                    FrameLoader._unloadImageWithPlist(item, true);
                    console.log("forceRelease FrameLoader._unloadImageWithPlist", plist[i])
                }

            }
            cc.loader.forceRelease(item)
            console.log("forceRelease cc.loader.forceRelease", item)
        })
        if (cc.sys.platform === cc.sys.WECHAT_GAME) {
            mini.triggerGC()
        }
    }
}

function splitPath(filepath) {
    let prefix = filepath.replace(/(?=.)\..+$/, '');
    let dir = prefix.split(/(?=_|\/)/g);
    if (prefix.length < filepath.length)
        dir.push(filepath.substring(prefix.length));
    return dir;
}

class ZipMap {
    constructor() {
        this.maps = [];
        this.exts = [];
    }

    /**
     * 增加一条Zip映射信息
     * @param {*} md5 
     * @param {*} ext 
     * @param {*} zipMd5 
     */
    add(md5, ext, zipMd5) {
        ext = ext || ''
        let index = this.exts.indexOf(ext);
        let map = null;
        if (index < 0) {
            this.exts.push(ext);
            map = {};
            this.maps.push(map);
        } else {
            map = this.maps[index];
        }
        
        map[md5] = zipMd5;
    }
    
    remove(shortPath) {
        let key = shortPath.replace(/(?=.)\..+$/, '');
        let ext = shortPath.substring(key.length);
        
        let index = this.exts.indexOf(ext);
        if (index < 0) 
            return;

        let map = this.maps[index];
        delete map[key];
    }

    get(shortPath) {
        let key = shortPath.replace(/(?=.)\..+$/, '');
        let ext = shortPath.substring(key.length);

        let index = this.exts.indexOf(ext);
        if (index < 0) 
            return;

        let map = this.maps[index];

        return map.hasOwnProperty(key)? map[key] + '.zip': null;
    }
}
class Md5Map {
    constructor() {
        this.data = null;
    }

    /**
     * 添加新数据
     * @param {*} map  数据
     */
    addMap(map) {
        if (this.data == null)
            this.data = map;
        else {
            Object.assign(this.data, map);
        }
    }

    add(shortPath, md5Path) {
        let ary = splitPath(shortPath);
        
        if (this.data == null)
            this.data = {}
        let cur = null, last = this.data
        for(let i = 0, v = ary[i]; i < ary.length - 1; i++, v = ary[i]) {
            cur = last[v];
            if (!cur) {
                cur = {}
                last[v] = cur;
            } else if (typeof cur !== 'object') {
                cur = {'': cur}
                last[v] = cur;
            }
            last = cur;
        }
        cur = last[ary[ary.length - 1]];
        if (cur && typeof cur === 'object') {
            cur[''] = md5Path;
        } else {
            last[ary[ary.length - 1]] = md5Path;
        }
    }

    get(shortPath) {
        if (!shortPath)
            return {md5: null, zip: null};
            
        let list = splitPath(shortPath);
        let current = this.data, dir = null, lastKey = null;
        list.some((v, index, ary)=> {
            if (!current)
                return true;
            else {
                if (index == ary.length - 1) {
                    dir = current;
                    lastKey = v;
                }
                current = current[v];
            }
        })
        if (current && typeof current === 'object') {
            dir = current;
            lastKey = '';
            current = current[lastKey];
        }
        
        if (typeof current === 'string') {
            let zip = dir[lastKey + '.zip'];
            return {md5: current, zip: typeof zip === 'string'? zip: null};
        } 

        return {md5: null, zip: null};
    }

    getFlat() {
        if (!this.data)
            return {};
        else 
            return getObjectValueRecursive(this.data);
    }
}


function getObjectValueRecursive(obj, results = {}) {
    for (let key in obj) {
        let value = obj[key]
        if (typeof value === 'object') {
            getObjectValueRecursive(value, results)
        } else {
            results[value + key.replace(/.+\./, '.')] = true
        }
    }
    return results
}

module.exports = ResourceManager